module.exports = __webpack_public_path__ + "img/scantop.5d76ab2b.jpg";